import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Button, Grid, Input, Item } from "semantic-ui-react";
import LasMaterialApi from "../../api/lasMaterial";
import Logo from "../../components/Logo/Logo";

import { useAppSelector as useSelector } from "../../hooks/redux";
import { isValidLeadTimeDays } from "../../utils/validLeadTimeDays";

import style from "./style.module.css";

export default function LasMaterialFormPage() {
  const params = useLocation();
  const isSimples = params.state === "Simples";

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const state = useSelector((s) => s);
  const history = useHistory();
  const [price, setPrice] = useState("");
  const [leadTimeDays, setLeadTimeDays] = useState("");
  const validForm = () => {
    if (price === "" || !isValidLeadTimeDays(leadTimeDays)) {
      return false;
    }
    return true;
  };

  const saveLasMaterial = async () => {
    setLoading(true);
    setError("");
    try {
      await LasMaterialApi.updateLasMaterial(
        price,
        parseInt(leadTimeDays, 10),
        state.lasMaterial.lasMaterial!.id
      );
      history.replace("/lasMaterialContract");
    } catch (err) {
      console.log(err);
    }
    setError("Error al guardar lasMaterial");
    setLoading(false);
  };

  const loadLasMaterial = async () => {
    try {
      const updateLasMaterial = await LasMaterialApi.getUpdatedLasMaterial(
        state.lasMaterial.lasMaterial!.id
      );
      if (updateLasMaterial) {
        setPrice(updateLasMaterial.price ? updateLasMaterial.price : "");
        setLeadTimeDays(
          updateLasMaterial.leadTimeDays ? updateLasMaterial.leadTimeDays.toString() : ""
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    loadLasMaterial();
    // eslint-disable-next-line
  }, []);

  const validateCurrency = (s: string) => {
    if (s.length === 0) {
      return true;
    }

    if (s.includes(".") && s.split(".").length - 1 > 1) {
      return false;
    }

    if (s.split(".")[1] && s.split(".")[1].length > 2) {
      return false;
    }

    if (s.replaceAll(".", "").match(/\D/g) === null) {
      return true;
    }

    return false;
  };

  return (
    <div className={style.container}>
      <Logo />
      <Grid columns={isSimples ? 4 : 5} stackable>
        <Grid.Column>
          <Item.Group>
            <Item>
              <Item.Content>
                <Item.Header>LasMaterial/Servicio</Item.Header>
                <Item.Meta>
                  <label>Código:</label>
                  <span>{state.lasMaterial.lasMaterial?.material}</span>
                  <br />
                  <label>Precio Neto:</label>
                  <span>{state.lasMaterial.lasMaterial?.price}</span>
                  <br />
                  <label>Descripción:</label>
                  <span>{state.lasMaterial.lasMaterial?.description}</span>
                </Item.Meta>
                <Item.Description>{}</Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Precio Bruto *:</label>
            <br />
            <label>(valor total incluyendo todos los tributos aplicables)</label>
            <br />
            <Input
              value={price}
              onChange={(e) => {
                if (validateCurrency(e.target.value.replace(",", "."))) {
                  setPrice(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(price))) {
                  setPrice("");
                } else {
                  setPrice(parseFloat(price).toFixed(2));
                }
              }}
              placeholder="Precio Bruto"
            />
          </Grid.Row>
          <br />
          <Grid.Row textAlign="left">
            <label>Plazo de Entrega (Número en días) *: </label>
            <br />
            <br />
            <Input
              type="number"
              min={1}
              step={1}
              value={leadTimeDays}
              onChange={(e) => {
                setLeadTimeDays(e.target.value);
              }}
              placeholder="Plazo de Entrega (Número en días)"
            />
          </Grid.Row>
        </Grid.Column>
        <Grid.Column>
          <Grid.Row>
            <Button
              onClick={() => {
                history.goBack();
              }}
              color="red"
            >
              Cancelar
            </Button>
            <Button
              loading={loading}
              disabled={!validForm()}
              onClick={saveLasMaterial}
              primary
            >
              Guardar
            </Button>
            <text className={style.error}>{error}</text>
          </Grid.Row>
        </Grid.Column>
      </Grid>
    </div>
  );
}
